import React from 'react';
import PropTypes from 'prop-types';
import { formatNumber } from './datasetMonitorFormat';

/**
 * CoverageBar
 *
 * Column 4 ("Coverage 24h"): the raw ran/expected counts plus a proportion
 * bar. Counts are always shown alongside the bar, never only a percentage -
 * "22%" alone does not tell an admin whether that means 412 of 1,904 or 4
 * of 18 (design spec 5, coverage decision).
 *
 * Renders nothing when no run has happened yet (both counts zero): day one
 * should read as absent, not as "0%". Blank rather than an em dash, matching
 * the other cells on this table.
 */
const CoverageBar = ({ ran, expected }) => {
	if (!ran && !expected) {
		return null;
	}

	const ratio = expected > 0 ? Math.min(1, ran / expected) : 0;

	return (
		<div className="coverage-bar">
			<div className="coverage-bar-track">
				<div
					className="coverage-bar-fill"
					style={{ width: `${ratio * 100}%` }}
				/>
			</div>
			<span className="coverage-bar-counts">
				{formatNumber(ran)} / {formatNumber(expected)}
			</span>
		</div>
	);
};

CoverageBar.propTypes = {
	ran: PropTypes.number,
	expected: PropTypes.number,
};

CoverageBar.defaultProps = {
	ran: 0,
	expected: 0,
};

export default CoverageBar;
